<template>
  <div
    class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0"
  >
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header mb-4"
      >
        <div class="md-layout">
          <div
            class="md-layout-item md-medium-size-100 md-size-100 truncated_header2"
          >
            <div class="md-layout md-alignment-center">
              <div
                class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60 p-0 report-header"
              >
                <h1 class="title-h4-formatting">
                  {{ this.headerData.title + ": " }}
                </h1>
                <ul>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">business_center</i
                      >Industry:
                    </p>
                    <p>{{ this.headerData.industry }}</p>
                  </li>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">apartment</i>Sector:
                    </p>
                    <p>{{ this.headerData.sector }}</p>
                  </li>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">place</i>Market Area:
                    </p>
                    <p>{{ this.headerData.area }}</p>
                  </li>
                </ul>
              </div>
              <div
                class="md-layout-item md-medium-size-100 md-xsmall-size-50 md-size-40 button-box"
              >
                <md-button
                  v-if="report && !Object.keys(report).length"
                  class="md-info access-button pdf_btn"
                >
                  <template>
                    <md-icon class="ml-5">picture_as_pdf</md-icon>Loading...
                  </template>
                </md-button>
                <md-button
                  v-if="pdfLoading"
                  class="md-info access-button pdf_btn"
                >
                  <template>
                    <md-icon class="ml-5">picture_as_pdf</md-icon>Downloading...
                  </template>
                </md-button>
                <md-button
                  v-if="report && Object.keys(report).length && !pdfLoading"
                  target="_blank"
                  class="md-info access-button pdf_btn"
                  @click="generateReport"
                >
                  <md-icon class="ml-5">picture_as_pdf</md-icon>Download PDF
                </md-button>
                <md-button
                  class="md-info access-button csv_btn"
                  @click.native="downloadCSVData"
                  ><md-icon class="ml-5">receipt_long</md-icon>Download CSV
                </md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="headerData && user"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
    >
      <IMRPDF
        :headerData="headerData"
        :user="user"
        :report="report"
        ref="html2Pdf"
      />
    </div>
  </div>
</template>

<script>
import ratingMixin from "@/mixins/rating-mixin";
import formatData from "@/mixins/format-data";
import { mapActions, mapState } from "vuex";
import IMRPDF from "./IMRPDF.vue";

Array.prototype.insert = function(index, item) {
  this.splice(index, 0, item);
};

export default {
  components: {
    IMRPDF,
  },
  mixins: [ratingMixin, formatData],
  props: ["headerData"],
  data() {
    return {
      filtered_population: [],
      filtered_market_volume: [],
      filtered_rank: [],
      filtered_market_share: [],
      filtered_annual_sales: [],
      filtered_penetration: [],
      filtered_employment: [],
      filtered_market_by_class: [],
      filtered_market_percent_by_class: [],
      filtered_average_sale_by_class: [],
      filtered_establishment_by_class: [],
      filtered_total_employment_by_class: [],
      filtered_average_employment_by_class: [],
      filtered_annual_sales_per_employee: [],
      filtered_average_annual_wage: [],
      filtered_rent_per_employee: [],
      filtered_startup_info: [],
      filtered_cessation_info: [],
      filtered_ownership_info: [],
      filtered_demographic_info: [],
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollarIndustry: [],
      filtered_PLPercentIndustry: [],
      filtered_PLDollarFirm: [],
      filtered_PLPercentFirm: [],
      filtered_PLDollarVariance: [],
      filtered_PLPercentVariance: [],
      filtered_BSDollarFirm: [],
      filtered_BSPercentFirm: [],
      filtered_BSDollarIndustry: [],
      filtered_BSPercentIndustry: [],
      filtered_BSDollarVariance: [],
      filtered_BSPercentVariance: [],
      filtered_CFDollarFirm: [],
      filtered_CFDollarIndustry: [],
      filtered_CFDollarVariance: [],
      filtered_PDollarFirm: [],
      filtered_PDollarIndustry: [],
      filtered_PDollarVariance: [],
      filtered_EDollarFirm: [],
      filtered_EDollarIndustry: [],
      filtered_EDollarVariance: [],
      filtered_DRDollarFirm: [],
      filtered_DRDollarIndustry: [],
      filtered_DRDollarVariance: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      report: (state) => state.user.market_report,
      companyClientName: (state) =>
        state.user.market_report.data.coverPage
          ? state.user.market_report.data.coverPage.client_text
          : "",
      companyClientLogo: (state) =>
        state.user.market_report.data.coverPage
          ? state.user.market_report.data.coverPage.client_img
          : "",

      tableCompetitors: (state) =>
        state.user.market_report.data.data["competitors"],
      annualSales: (state) =>
        state?.user?.market_report?.data
          ? state.user.market_report.data.data["annualSales"]
          : null,
      annualSalesCols: (state) =>
        state.user.market_report.data["annualSalesCols"],
      years: (state) => state.user.market_report.data.years,
      annualSalesRank: (state) =>
        state.user.market_report.data.data["annualSalesRank"]
          ? state.user.market_report.data.data["annualSalesRank"]
          : "",
      release_years: (state) =>
        state.user.market_report.data.general.release_years,
      cessation_years: (state) =>
        state.user.market_report.data.general.cessation_years,
      bznaics_code: (state) => state.user.market_report.data.general.bznaics,
      sector_name: (state) => state.user.market_report.data.general.sector,
      industry_title: (state) => state.user.market_report.data.general.industry,
      release_display: (state) =>
        state.user.market_report.data.general["release_display"],
      update_month: (state) => state.user.market_report.data.updateMonth,
      display_area: (state) =>
        state.user.market_report.data.general.area_display_name,
      marketVolume: (state) =>
        state.user.market_report.data.data["marketVolume"],
      marketShare: (state) => state.user.market_report.data.data["marketShare"],
      penetration: (state) => state.user.market_report.data.data["penetration"],
      employment: (state) => state.user.market_report.data.data["employment"],
      salesEmpSales: (state) =>
        state.user.market_report.data.data["salesEmpSales"],
      salesEmpCols: (state) => state.user.market_report.data["salesEmpCols"],
      salesEmpEmployment: (state) =>
        state.user.market_report.data.data["salesEmpEmployment"],
      productivity: (state) =>
        state.user.market_report.data.data["productivityValues"],
      startupPerformance: (state) =>
        state.user.market_report.data.data["startupsValues"],
      startupRates: (state) =>
        state.user.market_report.data.data["startupsIndex"],
      cessation: (state) => state.user.market_report.data.data["cessation"],
      ownership: (state) => state.user.market_report.data.data["ownership"],
      demographics: (state) =>
        state.user.market_report.data.data["demographics"],
      pdfLoading: (state) => state.user.pdfLoading,
    }),
    cessationLabel() {
      return this.cessation_years && this.cessation_years.length === 2
        ? `Cessation Rates (${this.cessation_years[0]}-${this.cessation_years[1]})`
        : 'Cessation Rates';
    },
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, "years");
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]["cashflow"];
    },
    pdfDownloadSetting() {
      return this.user &&
        this.user.preferences &&
        this.user.preferences.defaultPDFDownload
        ? this.user.preferences.defaultPDFDownload
        : "_blank";
    },
  },
  watch: {
    report() {
      if (this.report) this.parseCSVData();
    },
  },
  mounted() {
    this.$store.commit("user/SET_PDF_LOADING", false);
    if (this.report) this.parseCSVData();
  },
  methods: {
    ...mapActions({
      registerProductExport: "tracking/registerProductExport",
    }),
    generateReport() {
      this.$refs.html2Pdf.generateReport();
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "PDF",
      });
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          if (!this.$store.getters["user/pdfMustBeDownloaded"])
            window.open(pdf.output("bloburl"), "_blank");
        });
    },
    async getCsvData() {
      let csvData = [
        ["Bizminer Local Industry Market Report"],
        [this.bznaics_code, this.industry_title.replaceAll(",", " ")],
        ["Sector: " + this.sector_name],
        ["Zip Code " + this.display_area.replaceAll(",", " ")],
        ["Data Time Series", this.years.toString().replaceAll(",", "-")],
        ["Update Month", this.years.slice(-1)[0]],
        [""],
      ];
      csvData.push(["Industry Population Analyzed"], ["as of:", this.years]);
      this.filtered_population.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push(
        [""],
        ["Annual Industry Market Volume($)"],
        ["as of:", this.years]
      );
      this.filtered_market_volume.forEach((e, i) => {
        e.forEach((k, i) => {
          if (typeof k === "string" && k.includes(".")) {
            e[i] = k.replace(/\./g, "");
          }
        });
        csvData.push(e);
      });
      csvData.push([""], ["Share(%)"], ["", this.years]);
      this.filtered_market_share.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Average Annual Sales"]);
      csvData.push(["", this.annualSalesCols]);
      this.filtered_annual_sales.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      // TODO: Add rank filters
      csvData.push(["Rank"], ["as of:", this.years]);
      this.filtered_rank.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });

      csvData.push([""]);
      csvData.push(["Market Penetration ($)"]);
      csvData.push(["", this.years]);
      this.filtered_penetration.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push(
        [""],
        [
          "To enhance report load times Sales per Business Establishment values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser",
        ]
      );
      csvData.push([""], [""]);
      csvData.push(["Employment", this.years]);
      this.filtered_employment.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Market Volume by Employment Class", this.years]);
      this.filtered_market_by_class.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push(
        [""],
        ["Percent Market Volume by Employment Class", this.years]
      );
      this.filtered_market_percent_by_class.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Average Sales by Employment Class", this.years]);
      this.filtered_average_sale_by_class.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Establishments by Employment Class", this.years]);
      this.filtered_establishment_by_class.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Total Employment by Class", this.years]);
      this.filtered_total_employment_by_class.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Average Employment by Class", this.years]);
      this.filtered_average_employment_by_class.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Productivity"]);
      csvData.push(["Annual Sales per Employee", this.years]);
      this.filtered_annual_sales_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Average Annual Wage", this.years]);
      this.filtered_average_annual_wage.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Rent per Employee", this.years]);
      this.filtered_rent_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Productivity Indices (%)", this.years]);
      csvData.push([""]);
      csvData.push(["Startup Activity and Performance"]);
      csvData.push(["", this.years]);
      this.filtered_startup_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""], [""]);
      csvData.push(
        [
          "To enhance report load times Concentration values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser",
        ],
        [""],
        [""],
        [""],
        [""],
        [this.cessationLabel]
      );
      this.filtered_cessation_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], ["Ownership/Consolidation Trends", this.years]);
      this.filtered_ownership_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], ["Market Area Demographic Highlights"]);
      csvData.push([
        "(based on zip codes co-joined with your market radius) (2015)",
      ]);
      this.filtered_demographic_info.forEach((element, index) => {
        element.forEach((el, i) => {
          csvData.push(el);
        });
        csvData.push([""]);
      });

      return csvData;
    },
    parseCSVData() {
      if (!this.report || !this.report.data) {
        return;
      }
      this.tableDataMarketAnnualSales = Object.entries(
        this.annualSales
      ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
      let me = this;
      this.tableDataMarketAnnualSales.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithCommas(e);
        });
        return item;
      });
      // this.colouredLineChart.data = {
      //   labels: this.years,
      //   series: this.tableDataMarketAnnualSales.map((item) => ({
      //     name: item.name,
      //     data: item.dates.map((i) => Math.round(Number(i))),
      //   })),
      // };
      let populationData = Object.entries(
        this.tableCompetitors
      ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
      this.filtered_population = [];

      populationData.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_population.push(r);
      });
      let marketVolume = Object.entries(this.marketVolume).map(
        ([table, data]) => ({
          name: table,
          dates: Object.values(data),
        })
      );
      marketVolume.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithCommas(e);
        });
        return item;
      });
      let modifiedArr = [];
      marketVolume.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        modifiedArr.push(r);
      });
      this.filtered_market_volume = [];
      modifiedArr.forEach((el) => {
        let modified = el.map(function(el) {
          if (typeof el === "string" && el.includes(",")) {
            return el.replace(/,/g, ".");
          }
          return el;
        });
        this.filtered_market_volume.push(modified);
      });
      let marketShare = Object.entries(this.marketShare).map(
        ([table, data]) => ({
          name: table,
          dates: Object.values(data),
        })
      );
      this.filtered_market_share = [];
      marketShare.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_market_share.push(r);
      });
      let tableAnnual = Object.entries(this.annualSales).map(
        ([table, data]) => ({
          name: table,
          dates: Object.values(data),
        })
      );
      tableAnnual.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      this.filtered_annual_sales = [];
      tableAnnual.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_annual_sales.push(r);
      });
      let rank = Object.entries(this.annualSalesRank).map(([table, data]) => ({
        name: table,
        dates: Object.values(data),
      }));
      rank.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      this.filtered_rank = [];
      rank.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_rank.push(r);
      });
      let penetrationData = Object.entries(this.penetration).map(
        ([table, data]) => ({
          name: table,
          dates: Object.values(data),
        })
      );
      penetrationData.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      this.filtered_penetration = [];
      penetrationData.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_penetration.push(r);
      });
      let employmentData = Object.entries(this.employment).map(
        ([table, data]) => ({
          name: table,
          dates: Object.values(data),
        })
      );
      this.filtered_employment = [];
      employmentData.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_employment.push(r);
      });
      let marketVolumeByClass = Object.entries(
        this.salesEmpSales.marketVolume
      ).map(([name, data]) => ({
        name,
        dates: data,
      }));
      this.filtered_market_by_class = [];
      this.salesEmpCols.forEach((element, index) => {
        let b = [];
        marketVolumeByClass.forEach((el, num) => {
          b.push(el.dates[index]);
        });
        b.unshift(element);
        this.filtered_market_by_class.push(b);
      });
      let marketPercentVolumeByClass = Object.entries(
        this.salesEmpSales.percentMarket
      ).map(([name, data]) => ({
        name,
        dates: data,
      }));
      this.filtered_market_percent_by_class = [];
      this.salesEmpCols.forEach((element, index) => {
        let b = [];
        marketPercentVolumeByClass.forEach((el, num) => {
          b.push(el.dates[index]);
        });
        b.unshift(element);
        this.filtered_market_percent_by_class.push(b);
      });
      let averageSaleByClass = Object.entries(
        this.salesEmpEmployment.average
      ).map(([name, data]) => ({
        name,
        dates: data,
      }));
      this.filtered_average_sale_by_class = [];
      this.salesEmpCols.forEach((element, index) => {
        let b = [];
        averageSaleByClass.forEach((el, num) => {
          b.push(el.dates[index]);
        });
        b.unshift(element);
        this.filtered_average_sale_by_class.push(b);
      });
      let establishmentByClass = Object.entries(
        this.salesEmpEmployment.establishments
      ).map(([name, data]) => ({
        name,
        dates: data,
      }));
      this.filtered_establishment_by_class = [];
      this.salesEmpCols.forEach((element, index) => {
        let b = [];
        establishmentByClass.forEach((el, num) => {
          b.push(el.dates[index]);
        });
        b.unshift(element);
        this.filtered_establishment_by_class.push(b);
      });
      let totalEmploymentByClass = Object.entries(
        this.salesEmpEmployment.total
      ).map(([name, data]) => ({
        name,
        dates: data,
      }));
      this.filtered_total_employment_by_class = [];
      this.salesEmpCols.forEach((element, index) => {
        let b = [];
        totalEmploymentByClass.forEach((el, num) => {
          b.push(el.dates[index]);
        });
        b.unshift(element);
        this.filtered_total_employment_by_class.push(b);
      });
      let averageEmploymentByClass = Object.entries(
        this.salesEmpEmployment.average
      ).map(([name, data]) => ({
        name,
        dates: data,
      }));
      this.filtered_average_employment_by_class = [];
      this.salesEmpCols.forEach((element, index) => {
        let b = [];
        averageEmploymentByClass.forEach((el, num) => {
          b.push(el.dates[index]);
        });
        b.unshift(element);
        this.filtered_average_employment_by_class.push(b);
      });
      let annualSalesPerEmployee = Object.entries(
        this.productivity.spe
      ).map(([name, data]) => ({ name, dates: data }));
      annualSalesPerEmployee.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      this.filtered_annual_sales_per_employee = [];
      annualSalesPerEmployee.forEach((element, index) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((el) => {
          r.push(el);
        });
        r.unshift(element.name);
        this.filtered_annual_sales_per_employee.push(r);
      });
      let averageAnnualWage = Object.entries(
        this.productivity.annualWage
      ).map(([name, data]) => ({ name, dates: data }));
      averageAnnualWage.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      this.filtered_average_annual_wage = [];
      averageAnnualWage.forEach((element, index) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((el) => {
          r.push(el);
        });
        r.unshift(element.name);
        this.filtered_average_annual_wage.push(r);
      });
      this.filtered_rent_per_employee = [];
      let rentPerEmployee = Object.entries(
        this.productivity.rent
      ).map(([name, data]) => ({ name, dates: data }));
      rentPerEmployee.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      rentPerEmployee.forEach((element, index) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((el) => {
          r.push(el);
        });
        r.unshift(element.name);
        this.filtered_rent_per_employee.push(r);
      });
      let startupPerformance = Object.entries(
        this.startupPerformance
      ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
      startupPerformance.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      this.filtered_startup_info = [];
      startupPerformance.forEach((element, index) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((el) => {
          r.push(el);
        });
        r.unshift(element.name);
        this.filtered_startup_info.push(r);
      });
      let startupRates = Object.entries(
        this.startupRates
      ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
      startupRates.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      this.filtered_startup_info = [];
      startupRates.forEach((element, index) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((el) => {
          r.push(el);
        });
        r.unshift(element.name);
        this.filtered_startup_info.push(r);
      });
      let cessationRates = Object.entries(
        this.cessation
      ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
      this.filtered_cessation_info = [];
      cessationRates.forEach((element, index) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((el) => {
          r.push(el);
        });
        r.unshift(element.name);
        this.filtered_cessation_info.push(r);
      });
      let ownerShip = Object.entries(this.ownership).map(([table, data]) => ({
        name: table,
        dates: Object.values(data),
      }));
      this.filtered_ownership_info = [];
      ownerShip.forEach((element, index) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((el) => {
          r.push(el);
        });
        r.unshift(element.name);
        this.filtered_ownership_info.push(r);
      });
      let demographicInfo = Object.entries(
        this.demographics
      ).map(([table, data]) => ({ name: table, data: Object.values(data) }));
      this.filtered_demographic_info = [];
      demographicInfo.forEach((element, index) => {
        this.filtered_demographic_info[index] = [];
        this.filtered_demographic_info[index].push([element.name]);
        if (element.data.length > 1) {
          element.data.forEach((el, i) => {
            Object.keys(el).forEach((key) => {
              let a = el[key];
              a = a.map((e) => {
                if (typeof e == "string" && e.includes(",")) {
                  return me.numberWithPoints(e);
                } else {
                  return e;
                }
              });
              if (!a.includes(key)) {
                a.unshift(key);
              }
              this.filtered_demographic_info[index].push(a);
            });
          });
        } else {
          element.data.forEach((el, i) => {
            Object.keys(el).forEach((key) => {
              let a = el[key];
              a = a.map((e) => {
                if (typeof e == "string" && e.includes(",")) {
                  return me.numberWithPoints(e);
                } else {
                  return e;
                }
              });
              if (!a.includes(key)) {
                a.unshift(key);
              }
              this.filtered_demographic_info[index].push(a);
            });
          });
        }
      });

      this.filtered_demographic_info[6].insert(3, [""]);
      this.filtered_demographic_info[6].insert(14, [""]);
      this.filtered_demographic_info[6].insert(25, [""]);
      this.filtered_demographic_info[6].insert(30, [""]);
      this.filtered_demographic_info[6].insert(42, [""]);


    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (!x) {
        return "";
      }
      if (typeof x === "number") {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return x.replace(/,/g, ".");
      }
    },
    async downloadCSVData() {
      let csv = "";
      await this.parseCSVData();
      let csvData = await this.getCsvData();
      await csvData.forEach((row) => {
        csv += row.join(",");
        csv += "\n";
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Industry Market Report.csv";
      anchor.click();
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "CSV",
      });
    },
  },
};
</script>
<style lang="scss"></style>
